import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon, LockIcon, SparklesIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="final-cta" className="bg-forest py-20 md:py-32 relative overflow-hidden" data-id="element-68">
      <div className="absolute inset-0 opacity-10 pointer-events-none" aria-hidden="true" data-id="element-69">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-gold blur-3xl" data-id="element-70"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-gold-light blur-3xl" data-id="element-71"></div>
      </div>

      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-73">
          <SparklesIcon className="w-8 h-8 text-gold-light mx-auto mb-6" aria-hidden="true" data-id="element-74" />

          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-warm-white mb-8 leading-tight" data-id="element-75">
            Tal vez tu cuerpo no está{' '}
            <span className="italic text-gold-light" data-id="element-76">
              trabajando en tu contra.
            </span>
          </h2>

          <p className="font-serif italic text-xl md:text-2xl lg:text-3xl text-warm-white/95 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-77">
            Tal vez solo necesita una forma diferente de ser escuchado.
          </p>

          <motion.a href="https://www.abeautifulage.com/cart/53764329210222:1" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.03,
          boxShadow: '0 25px 60px -10px rgba(201, 168, 76, 0.6)'
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0 15px 40px -10px rgba(201, 168, 76, 0.4)', '0 20px 50px -10px rgba(201, 168, 76, 0.6)', '0 15px 40px -10px rgba(201, 168, 76, 0.4)']
        }} transition={{
          boxShadow: {
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative w-full lg:w-auto bg-gold text-charcoal px-10 md:px-14 py-6 md:py-7 rounded-lg text-base md:text-lg lg:text-xl font-bold inline-flex items-center justify-center gap-3 max-w-2xl mx-auto" data-id="element-78">
            Descubrir el Método
            <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-79" />
          </motion.a>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mt-10 text-warm-white/85 text-sm md:text-base" data-id="element-80">
            <span className="flex items-center gap-2" data-id="element-81">
              <SparklesIcon className="w-4 h-4 text-gold-light" data-id="element-82" />
              Acceso inmediato
            </span>
            <span className="hidden md:inline text-warm-white/40" data-id="element-83">•</span>
            <span className="flex items-center gap-2" data-id="element-84">
              <LockIcon className="w-4 h-4 text-gold-light" data-id="element-85" />
              Pago 100% seguro
            </span>
            <span className="hidden md:inline text-warm-white/40" data-id="element-86">•</span>
            <span className="flex items-center gap-2" data-id="element-87">
              <ShieldCheckIcon className="w-4 h-4 text-gold-light" data-id="element-88" />
              Garantía 60 días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}